// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h3[data-v-a560f656]{color:#464646}.add-block-content[data-v-a560f656]{color:#8b8b8b;font-style:italic}.add-block-content span.icon[data-v-a560f656]{float:left}.answer-block[data-v-a560f656]{background-color:transparent!important}.divider-dashed-style[data-v-a560f656]{border:dashed #b4b4b4;border-width:3px 0 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
